import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MotivoCancelamentoMarcacao } from '../../marcacao/motivo-cancelamento-marcacao';

@Component({
  selector: 'app-informacao-cancelamento-detail',
  templateUrl: './informacao-cancelamento-detail.component.html',
  styleUrls: ['./informacao-cancelamento-detail.component.css']
})
export class InformacaoCancelamentoDetailComponent implements OnInit {

  motivoCancelamentoMarcacao: MotivoCancelamentoMarcacao;

  formularioInformacaoCancelamento: FormGroup;

  constructor(private router: Router,
    private formBuilder: FormBuilder) {

    this.motivoCancelamentoMarcacao = Object.assign(new MotivoCancelamentoMarcacao(), history.state.motivoCancelamentoMarcacao);

    this.formularioInformacaoCancelamento = this.formBuilder.group({
      idUserCancelamento: '',
      loginUserCancelamento: '',
      dataCancelamento: '',
      dataCancelamentoFormatada: '',
      obsMotivoCancelamento: '',
      motivoCancelamento: this.formBuilder.group({
        id: '',
        descricao: ''
      })
    });
  }

  ngOnInit() {

    this.configurarForm();
  }

  gotoList() {
    const paginaAnterior = history.state.paginaAnterior;

    this.router.navigate(['/' + paginaAnterior], {
      state: {
        filtroMarcacao: history.state.filtroMarcacao,
        textFilter: history.state.textFilter,
      }
    });
  }

  configurarForm(): void {

    this.motivoCancelamentoMarcacao.dataCancelamentoFormatada = formatDate(this.motivoCancelamentoMarcacao.dataCancelamento, 'dd/MM/yyyy HH:mm:ss', 'en');

    this.formularioInformacaoCancelamento.setValue(this.motivoCancelamentoMarcacao);
    this.formularioInformacaoCancelamento.disable();
  }

}
